import React from 'react';
import {withRouter, Link} from 'react-router-dom';
import {inject, observer} from 'mobx-react';
import {observe} from 'mobx';
import HttpClient from 'services/HttpClient'
import Modal from 'react-modal';
import Pagination from './Pagination';
import 'styles/css/pagination.scss';
import {ProviderCard} from './ProviderCard';
import SearchField from './SearchField';
import {THERAPY_PROVIDERS} from "stores/WorkshopsUrlConstants";
import {
  DELETE_PROVIDER,
  GET_PROVIDER_WORKSHOP,
  GET_PROVIDERS
} from 'constants/backend_routes';


let queryParams = '';

@withRouter
@inject('user')
@inject('searchFieldEventEmitter')
@inject('providerStore')
export default class ProvidersList extends React.Component {
  state = {
    providers: [],
    provider_name: '',
    type: null,
    pagesCount: 0,
    modalDeleteProviderOpened: false,
    deletedObject: null
  }


  componentWillMount() {
    // this.setState({count: this.props.count});
    this.subscriber = observe(this.props.searchFieldEventEmitter, 'event', () => this.loadNewProviders());
    this.subscriber = observe(this.props.searchFieldEventEmitter, 'page', () => this.loadNewProviders());
    // this.subscriberReset = observe(this.props.searchFieldEventEmitter,'resetEvent', () =>  this.resetFilters() );

    this.props.searchFieldEventEmitter.setInitialState();
    this.initialize(this.props.location.pathname);
    this.routerListener = this.props.history.listen((location, action) => {
      this.props.searchFieldEventEmitter.setInitialState();
      this.initialize(location.pathname);
    });
  }

  componentWillUnmount = () => {
    this.subscriber();
    this.routerListener();
    this.props.providerStore.getProviders(this.state.providers);
  };

  handleChangeTitle = newTitle => {
    this.setState({provider_name: newTitle});
  };

  loadNewProviders = () => {
    queryParams = `&name=${this.state.provider_name}&page=${this.props.searchFieldEventEmitter.page}`;
    if (this.state.type === THERAPY_PROVIDERS) {

      new HttpClient().get(GET_PROVIDERS + queryParams).then(response => {
          this.setState({
            providers: response.body.data.providers,
            count: response.body.data.count,
            pagesCount: response.body.data.pages
          });
          this.props.providerStore.getProviders(this.state.providers);
          this.props.searchFieldEventEmitter.setTotalPages(this.state.pagesCount)
          console.log('state in loadNewProviders()', this.state);
          console.log('this.state.provider_name', this.state.provider_name);
          console.log('queryParams providers', queryParams);
        }
      )
    }
  }

  initialize = pathName => {
    let type;
    // this.props.searchFieldEventEmitter.handleReset();
    if (pathName.includes(THERAPY_PROVIDERS))
      type = THERAPY_PROVIDERS;
    this.setState({
      type: type, title: ''
    }, () => this.loadNewProviders(''));
  };

  decline = () => {
    this.setState({
      modalDeleteProviderOpened: false
    })
  };

  handleDeleteModalProvider = (e, id) => {
    e.preventDefault();
    e.stopPropagation();
    this.setState({modalDeleteProviderOpened: true, deletedObject: id})
  }

  deleteProvider = () => {
    new HttpClient().delete(`${DELETE_PROVIDER}${this.state.deletedObject}`).then(response => {
      let providers = [...this.state.providers];
      let deletedIndex = providers.findIndex(el => el.id === this.state.deletedObject);
      providers.splice(deletedIndex, 1);
      this.setState({
        providers: providers,
        modalDeleteProviderOpened: false,
        deletedObject: null
      })
    })
  }

  handleEditProvider = (e, id) => {
    e.preventDefault();
    e.stopPropagation();
    this.props.providerStore.getProvider(id);
    this.props.history.push(`/provider/${id}`)
  }

  redirectToProviderBio = (provider_id) => {
    this.props.providerStore.getProvider(provider_id);
    console.log('this.props.providerStore.provider', this.props.providerStore.provider);
    this.props.history.push(`/provider_bio/${provider_id}`)
  }

  closeIcon = () => {
    this.setState({provider_name: ''}, () => {
      this.props.searchFieldEventEmitter.activate();
    });
  }


  handleCreateProvider = () => {
    if (this.props.user.userLoggedIn() && this.props.user.getUser().role === 'admin') {
     return (
       <div className="provider-card-wrapper col-12 col-md-6 col-lg-4 ">
         <Link className="add-new-provider provider-card card" to="/provider">
           <div>
              <span className="icon">
              </span>
           </div>
           <span>ADD NEW PROVIDER</span>
         </Link>
       </div>
     )
    } else {
      return null
    }
  }


  render() {
    // console.log('state in provider_list', this.state);

    // console.log('this.state.providers', this.state.providers);

    return (
      <main className="main-content purchased">
        <Modal
          isOpen={this.state.modalDeleteProviderOpened}
          closeTimeoutMS={100}
          contentLabel="Modal"
        >
          <h1>Are you sure you want to delete this Provider?</h1>
          <div className="modal-permissions-button">
            <div className="workshop-creator-sidebar-publish">
              <span className="btn prime bordered" onClick={this.deleteProvider}>Delete</span></div>
            <div className="workshop-creator-sidebar-publish" style={{marginLeft: 15}}>
              <span className="btn prime bordered red" onClick={this.decline}>Decline</span></div>
          </div>
        </Modal>
        <div className="providers-list workshop-list dashboard container-fluid">
          <div className="provider-search-wrap">
            <SearchField
              // submitFilter={this.loadNewProviders
              // count={this.state.count}
              value={this.state.provider_name}
              handleChangeTitle={this.handleChangeTitle}
              closeIcon={this.closeIcon}
            />
          </div>
          <div className="providers-card-list">
            {
              this.state.providers && this.state.providers.map(el => {
                return (
                  <ProviderCard key={`provider ${el.id}`}
                                provider={el}
                                redirectToProvider={this.redirectToProviderBio}
                                handleEditProvider={this.handleEditProvider}
                                handleDeleteProvider={this.handleDeleteModalProvider}
                  />
                )
              })
            }
            {
              this.handleCreateProvider()
            }
          </div>
          {this.state.count ?
            < Pagination/> : null
          }
        </div>
      </main>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/providers/ProvidersList.jsx